import { Box, Stack, useMediaQuery } from '@mui/material';
import CrmFooter from '../crm/main/CrmFooter';
import { ReactNode } from 'react';
import json2mq from 'json2mq';
const background = '/resources/images/loghi/FOCUS-CLOUD.jpg';

interface EmptyPageProps {
  children?: ReactNode;
}

function EmptyPage({ children }: EmptyPageProps) {
  const matchesSmall = useMediaQuery(
    json2mq({
      maxWidth: 1024,
    }),
  );

  let backgroundGradient =
    'linear-gradient(90deg, rgba(255, 255, 255, 0) 40%, rgba(22, 65, 148, 1) 100%)';

  if (matchesSmall) {
    backgroundGradient =
      'linear-gradient(90deg, rgba(255, 255, 255, 0.8) 10%, rgba(22, 65, 148, 1) 100%)';
  }

  return (
    <Stack
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 100,
        backgroundColor: 'white',
      }}
      flexDirection="column"
    >
      <Stack
        flex={1}
        sx={{ position: 'relative' }}
        justifyContent="center"
        alignItems="center"
      >
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `url(${background})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            '&:after': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: backgroundGradient,
            },
          }}
        />
        {children}
      </Stack>
      <CrmFooter disableUpdateClick={true} transparent={true} />
    </Stack>
  );
}

export default EmptyPage;
